module.exports = __webpack_public_path__ + "static/media/10d.5d8c2237.png";